import React from 'react'
import { connect } from 'react-redux'
import Part from './Part'
import { AppState } from '../reducers';

const directions = {
    TOP: 'top',
    BOTTOM: 'bottom'
}

type PartListProps = ReturnType<typeof mapStateToProps>

class PartList extends React.Component<PartListProps> {
    firstNotEmptyInput
    secondNotEmptyInput
    topNotEmptyInputSignal
    bottomNotEmptyInputSignal
    partList

    FindNotEmptyInputs(articles) {
        let result = []
        for (let i = 0; i < articles.length; i++) {
            if (articles[i].count > 0) {
                result.push(articles[i].index)
                for (let j = articles.length - 1; j > i; j--) {
                    if (articles[j].count > 0) {
                        result.push(articles[j].index)
                        break
                    }
                }
                break
            }
        }
        return result
    }

    IsOutOfSight(element, window, direction) {
        switch (direction) {
            case directions.TOP:
                return element.offsetTop + element.offsetHeight < window.top
            case directions.BOTTOM:
                return element.offsetTop > window.bottom
            default:
                return false
        }
    }

    ToggleInputsSignals(list) {
        let showTop = false, showBottom = false

        if (this.firstNotEmptyInput) {
            let listTopEdge = list.offsetTop + list.scrollTop
            let window = { top: listTopEdge, bottom: listTopEdge + list.offsetHeight }

            showTop = this.IsOutOfSight(this.firstNotEmptyInput, window, directions.TOP)
            showBottom = this.IsOutOfSight(this.secondNotEmptyInput ? this.secondNotEmptyInput : this.firstNotEmptyInput, window, directions.BOTTOM)
        }

        this.topNotEmptyInputSignal.style.display = showTop ? null : "none"
        this.bottomNotEmptyInputSignal.style.display = showBottom ? null : "none"
    }

    render() {
        let { articles, selected, newOrderApplication } = this.props

        const list = articles.map(article => {
            let expanded = selected === article.id
            return (
                <li
                    ref={null}
                    key={article.id}
                >
                    <Part article={article} selected={selected === article.id} expanded={expanded} />
                </li>
            )
        })

        return (
            <div id="kr-left-menu" className="kr-flex">
                <div id="kr-listDiv">
                    <div ref={node => { this.topNotEmptyInputSignal = node }} style={{ display: "none" }}>
                        <div id="kr-partListArrowTop" className="kr-partListArrow"></div>
                        <hr id="kr-listLineT" className="kr-hr" />
                    </div>
                    <ul
                        id="kr-list"
                        onScroll={(e) => { if (!newOrderApplication) this.ToggleInputsSignals(e.target) }}
                        ref={node => { this.partList = node }}>
                        {list}
                    </ul>
                    <div ref={node => { this.bottomNotEmptyInputSignal = node }} style={{ display: "none" }}>
                        <hr id="kr-listLineB" className="kr-hr" />
                        <div id="kr-partListArrowBottom" className="kr-partListArrow"></div>
                    </div>
                </div>
            </div>
        )
    }

    componentDidUpdate() {
        this.ToggleInputsSignals(this.partList)
    }
}

const mapStateToProps = (state: AppState) => ({
    articles: state.filteredAssortment.products,
    selected: state.selected,
    newOrderApplication: state.config.newOrderApplication as boolean
})

export default connect(mapStateToProps)(PartList)
